/* eslint-disable no-undef */
import NProgress from "nprogress"
import React from "react"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Provider as ReduxProvider } from "react-redux"
import "sanitize.css"

import "./src/assets/fonts/stylesheet.css"
import { BaseContextProvider } from "./src/context/BaseContext"
import store from "./src/redux/store"
import "./src/styles/global.css"

const setLocation = () => {
  if (window) {
    const { hostname, pathname, protocol, search } = document.location

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      originalLocation: `${protocol}//${hostname}${pathname}${search}`,
    })
  }
}

export const onClientEntry = () => {
  const options = {
    color: "#F26722", // brandOrange
    showSpinner: false,
    trickleSpeed: 50,
  }
  const styles = `
    #nprogress {
     pointer-events: none;
    }
    #nprogress .bar {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background: ${options.color};
      z-index: 9000;
    }
    #nprogress .peg {
      display: block;
      position: absolute;
      right: 0px;
      width: 100px;
      height: 100%;
      -webkit-transform: rotate(3deg) translate(0px, -4px);
      -ms-transform: rotate(3deg) translate(0px, -4px);
      transform: rotate(3deg) translate(0px, -4px);
      box-shadow: 0 0 10px ${options.color}, 0 0 5px ${options.color};
      opacity: 1.0;
    }
  `

  const styleNode = document.createElement(`style`)
  styleNode.id = `nprogress-styles`
  styleNode.innerHTML = styles
  document.head.appendChild(styleNode)

  NProgress.configure(options)

  // Fix for Sentry issue UAG-WEB-M: Add retry logic for static query loading
  // Patch the static query loader with retry logic
  if (typeof window !== "undefined" && window.___loader) {
    const originalLoadStaticQuery = window.___loader.loadStaticQuery

    if (originalLoadStaticQuery) {
      window.___loader.loadStaticQuery = function (staticQueryHash) {
        const MAX_RETRIES = 3
        const INITIAL_DELAY = 300
        const MAX_DELAY = 3000
        const BACKOFF_MULTIPLIER = 2

        const retryFetch = async (attempt = 1) => {
          try {
            return await originalLoadStaticQuery.call(this, staticQueryHash)
          } catch (error) {
            if (attempt >= MAX_RETRIES) {
              // Log final failure to Sentry
              console.error(
                `Failed to load static query ${staticQueryHash} after ${MAX_RETRIES} attempts`,
                error
              )
              throw error
            }

            // Calculate delay with exponential backoff
            const delay = Math.min(
              INITIAL_DELAY * Math.pow(BACKOFF_MULTIPLIER, attempt - 1),
              MAX_DELAY
            )

            console.warn(
              `Retry ${attempt}/${MAX_RETRIES} loading static query ${staticQueryHash} after ${delay}ms`,
              error
            )

            // Wait before retrying
            await new Promise((resolve) => setTimeout(resolve, delay))

            // Retry
            return retryFetch(attempt + 1)
          }
        }

        return retryFetch()
      }
    }
  }
}

export const onInitialClientRender = () => {
  setLocation()
}

export const onRouteUpdateDelayed = () => {
  NProgress.start()
}

export const onRouteUpdate = ({ location }) => {
  window.previousPath = window.currentPath || ""
  window.currentPath = location.pathname
  NProgress.done()
}

export const disableCorePrefetching = () => true

export const wrapRootElement = ({ element }) => {
  return (
    <ReduxProvider store={store}>
      <BaseContextProvider>{element}</BaseContextProvider>
    </ReduxProvider>
  )
}

// Fix for Sentry issue UAG-WEB-11: safely handle missing pageResources.page
// Note: replaceComponentRenderer is deprecated in Gatsby 5
// The error boundaries in Layout now handle most rendering errors
// If UAG-WEB-11 reoccurs, we may need to investigate alternative approaches
